import './travel-team.scss';
import Swiper from 'swiper/bundle';

export default () => {
//	new Swiper('.js-travel-team-swiper', {
//		loop: true,
//		effect: 'coverflow',
//		grabCursor: true,
//		centeredSlides: true,
//		slidesPerView: '1',
//		coverflowEffect: {
//			rotate: 0,
//			stretch: 10,
//			depth: 200,
//			modifier: 1,
//			slideShadows: false,
//		},
//		navigation: {
//			prevEl: ".travel-team-prev",
//			nextEl: ".travel-team-next",
//		},
//	});

    var galleryTop = new Swiper('.js-travel-team-top', {
        loop: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 0,
            stretch: 20,
            depth: 270,
            modifier: 2,
            slideShadows: false,
        },
        navigation: {
            nextEl: '.travel-team-prev',
            prevEl: '.travel-team-next',
        },
    });
    var galleryThumbs = new Swiper('.js-travel-team-thumbs', {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        loopedSlides: 4
    });
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;

    document.querySelectorAll('.accordion-title').forEach(title => {
        title.addEventListener('click', function () {
            setTimeout(function () {
                document.querySelectorAll('.travel-team-prev').forEach(btn => btn.click())
            }, 100)
        })
    })

};
